import { logger } from '@thrivent-web/logging-utils';
import { getCookie } from 'cookies-next';

const userId = getCookie('ANONYMOUS_USER_ID');

export const useTrackLDMetric = () => {
  const trackMetric = async (metricKey: string) => {
    try {
      const response = await fetch('/api/trackMetric', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ userId, metricKey }),
      });
      const data = await response.json();
      if (data.success) {
        logger.info(`Metric tracked successfully: ${metricKey}`, data);
      } else {
        logger.error('Error tracking metric:', data.error);
      }
    } catch (error) {
      logger.error('Error tracking metric:', error);
    }
  };
  return { trackMetric };
};
